import {MimeTypesEnum} from '../enums';


export default function isTypeForPdfConversion(type: string, name: string): boolean {
  return (type === MimeTypesEnum.ApplicationMSWordOpenXML || name.toLowerCase().indexOf('.docx') > -1 ||
    type === MimeTypesEnum.ApplicationMsExcelOpenXML || name.toLowerCase().indexOf('.xlsx') > -1 ||
    type === MimeTypesEnum.ApplicationMsPptOpenXML || name.toLowerCase().indexOf('.pptx') > -1);
}
